import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import CalculatingScreen from "../components/CalculatingScreen";
import { yearQueryOptions } from "../lib/queries";
import { yearSearchSchema } from "../lib/searchParams";
import YearResults from "../pages/YearResults";

export const Route = createFileRoute("/year-results")({
	validateSearch: zodValidator(yearSearchSchema),
	loaderDeps: ({ search }) => ({ lat: search.lat, lon: search.lon, year: search.year }),
	loader: ({ context, deps }) => context.queryClient.ensureQueryData(yearQueryOptions(deps)),
	pendingComponent: () => <CalculatingScreen label="Beregner soltider..." />,
	// Remount the page when lat/lon/year change so per-year UI state (e.g. the
	// selected terrain date) resets instead of carrying over between years.
	remountDeps: ({ loaderDeps }) => loaderDeps,
	component: YearResults,
});
